module.exports = __webpack_public_path__ + "img/Icon_Chevron_Left.0bed9c90.svg";